import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {LogType, PurchaseType, UserSource} from "@/store/player/types";
import DropDownList from "phaser3-rex-plugins/templates/ui/dropdownlist/DropDownList";
import SpriteUtils from "@/utils/sprite-utils";
import {SimpleDropDownList} from "@/scenes.ui/simple-drop-down-list";

export class PlayerHistorySettings extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, filterCallback: (logType: LogType, purchaseType: PurchaseType) => unknown) {
        super(scene, canvas, Tr('srch.sett'));

        let label = TextUtils.addTextByFamily(scene, Tr('filter.by.category'), 0, -180,
            '#ffd465', 18, 'bold', 300, Fonts.MYRIADPRO_REGULAR);

        let dropDown = new SimpleDropDownList(scene, canvas, 0, -140, Object.values(LogType), false, undefined,
            () => {
                dropDown2.visible = false;
                label2.visible = false;
            }, () => {
                if(dropDown.getValue() === LogType.GEMS){
                    dropDown2.visible = true;
                    label2.visible = true;
                }
            });

        let label2 = TextUtils.addTextByFamily(scene, Tr('filter.by.subcategory'), 0, -70,
            '#ffd465', 18, 'bold', 300, Fonts.MYRIADPRO_REGULAR);
        label2.visible = false;

        let dropDown2 = new SimpleDropDownList(scene, canvas, 0, -30, Object.values(PurchaseType), false);
        dropDown2.visible = false;

        this.addCloseButton(Tr('filter'), () => {
            let type = LogType[dropDown.getValue() as keyof typeof LogType];
            let subType = PurchaseType[dropDown2.getValue() as keyof typeof PurchaseType];
            filterCallback(type, subType)
        });

        this.add([label, label2, dropDown, dropDown2]);
    }

}
